











import { Subscription } from '@ssp/inscreva-sse-models';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import SubscriptionForm from '@/components/SubscriptionForm.vue';
import { subscriptionStore } from '@/store/subscription';

@Component({
  components: {
    Loading,
    SubscriptionForm,
  },
})
export default class SubscriptionPage extends Vue {
  private isLoading: boolean = true;

  private subscription: Subscription = null;

  async created() {
    this.subscription = await subscriptionStore.searchBy({ _id: this.$route.params.id });
    this.isLoading = false;
  }

  goSubscriptions() {
    return this.$router.replace({ path: '/subscriptions', replace: true });
  }
}
